import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './spinner.css';
import { captureGoogleClickIds } from './utils/googleAds';

captureGoogleClickIds();

// Supabase and fetch can abort in-flight requests (e.g. React Strict Mode, unmount, timeout). Those show up as
// "AbortError" / "signal aborted without reason". Suppress so the console and error reporting stay clean.
window.addEventListener('unhandledrejection', (event) => {
  const r = event?.reason;
  const isAbort = r?.name === 'AbortError' ||
    (typeof r?.message === 'string' && r.message.toLowerCase().includes('aborted'));
  if (isAbort) {
    event.preventDefault();
    event.stopImmediatePropagation?.();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
